import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./custom-calendar.css"; // Import your custom CSS
import { adminDashboardStyles } from "../../Styles/styles";
import { CalenderBackIcon, CalenderNextIcon } from "../../Svg/icons";
import {
  useGetCalenderEventsQuery,
  useGetEventsQuery,
} from "../../Redux/apis/ApiSlice";

export default function CustomCalendar() {
  const [eventName, setEventName] = useState("");
  const [organizerName, setOrganizerName] = useState("");
  const [status, setStatus] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [view, setView] = useState("month");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [open, setOpen] = useState(false);
  const { data: allEvents } = useGetEventsQuery({
    eventName,
    organizerName,
    status,
    startDate: startDate ? startDate.toISOString() : undefined,
    endDate: endDate ? endDate.toISOString() : undefined,
  });
  const localizer = momentLocalizer(moment);

  // New events from calenderEvents api
  const { data: calenderEvents } = useGetCalenderEventsQuery();
  const calEvents = Array.isArray(calenderEvents?.events)
    ? calenderEvents.events
    : [];

  // Transform API events into the format required by react-big-calendar
  const formatEvents = (events) => {

    return events
      .map((event) => {
        if (!event) return null;

        const {
          startDateTime,
          time,
          status,
          eventName,
          description,
          location,
          organizationName,
          color,
        } = event;


        const endDate = moment(startDateTime).add(1, "hour").toDate(); // Assuming 1 hour duration


        return {
          title: eventName,
          start: new Date(startDateTime),
          end: endDate,
          description,
          location,
          organizationName,
          status,
          color,
        };
      })
      .filter(Boolean);
  };

  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (calenderEvents && Array.isArray(calenderEvents.events)) {
      setEvents(formatEvents(calenderEvents.events));
    } else {
      console.warn(
        "calenderEvents is not an array or is undefined:",
        calenderEvents
      );
    }
  }, [calenderEvents]);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEvent(null);
  };

  function CustomToolbar(props) {
    // console.log("PROPSS",props.events)
    const goToBack = () => {
      let mDate = props.date;
      let newDate = new Date(mDate.setMonth(mDate.getMonth() - 1));
      props.onNavigate("prev", newDate);
    };

    const goToNext = () => {
      let mDate = props.date;
      let newDate = new Date(mDate.setMonth(mDate.getMonth() + 1));
      props.onNavigate("next", newDate);
    };

    const goToCurrent = () => {
      let now = new Date();
      props.onNavigate("current", now);
    };

    const handleViewChange = (view) => {
      setView(view);
      props.onView(view);
    };

    const yellowCount = props.events?.filter(
      (event) => event.color === "#A6E19C"
    ).length;
    const greenCount = props.events?.filter(
      (event) => event.color === "#B8D6F1"
    ).length;
    const redCount = props.events?.filter(
      (event) => event.color === "#FFAFB2"
    ).length;

    return (
      <>
        <div className="rbc-toolbar">
          <span className="rbc-btn-group">
            <IconButton onClick={goToBack}>
              <CalenderBackIcon />
            </IconButton>
            <Typography>{moment(props.date).format("MMMM")}</Typography>
            <IconButton onClick={goToNext}>
              <CalenderNextIcon />
            </IconButton>
          </span>
          <Box justifyContent={"space-evenly"}>
            <Button
              className={view === "month" ? "rbc-active" : ""}
              onClick={() => handleViewChange("month")}
            >
              Month
            </Button>
            <Button
              className={view === "week" ? "rbc-active" : ""}
              onClick={() => handleViewChange("week")}
            >
              Week
            </Button>
            <Button
              className={view === "day" ? "rbc-active" : ""}
              onClick={() => handleViewChange("day")}
            >
              Day
            </Button>
          </Box>
        </div>

        <div style={{ display: "flex", gap: "1rem" }}>
          <Box
            display="flex"
            alignItems="center"
            sx={{ marginTop: "12px", marginBottom: "14px" }}
          >
            <Box
              sx={{
                width: "10px",
                height: "10px",
                backgroundColor: "#A6E19C",
                marginRight: "7px",
              }}
            />
            <Typography
              sx={{ color: "#5A607F", fontWeight: 400, fontSize: "14px" }}
            >
              My Bookings ({yellowCount})
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: "10px",
                height: "10px",
                backgroundColor: "#B8D6F1",
                marginRight: "7px",
              }}
            />
            <Typography
              sx={{ color: "#5A607F", fontWeight: 400, fontSize: "14px" }}
            >
              My Events ({greenCount})
            </Typography>
          </Box>
          {/* <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: "10px",
                height: "10px",
                backgroundColor: "#FFAFB2",
                marginRight: "7px",
              }}
            />
            <Typography
              sx={{ color: "#5A607F", fontWeight: 400, fontSize: "14px" }}
            >
              Events Invites ({redCount})
            </Typography>
          </Box> */}
        </div>
      </>
    );
  }

  const eventStyleGetter = (event, start, end, isSelected) => {
    const backgroundColor = event.color || "#A6E19C"; // Directly using the backend color
    // console.log("Colors:::", event.color);
    const style = {
      backgroundColor: backgroundColor,
      color: "black",
      padding: "1px",
      margin: "2px 2px 2px 0",
      borderRadius: "10px",
      textAlign: "center",
      border: "1px solid #b3d4fc",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "9px",
      height: "25px", // Increase height for better visibility
      overflow: "hidden", // Prevent overflow issues
    };
    return {
      style: style,
      className: "calendar-event",
    };
  };

  return (
    <div>
      <Calendar
        eventPropGetter={eventStyleGetter}
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={adminDashboardStyles.AdminDashboardCalender}
        views={["month", "week", "day"]}
        components={{
          toolbar: (props) => <CustomToolbar {...props} events={events} />,
        }}
        onSelectEvent={handleEventClick}
      />

      {/* Event Details Modal */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "15px",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#f5f5f5",
            borderBottom: "1px solid #ddd",
            fontWeight: 600,
          }}
        >
          Event Details
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {selectedEvent && (
            <>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Name: {selectedEvent.title}
              </Typography>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Event Date:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 400, flexShrink: 1 }}
                >
                  {/* {moment(selectedEvent.start).format("MMMM D, YYYY")} */}
                  {moment(selectedEvent.start).format('MM/DD/YYYY')}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Event Time:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 400, flexShrink: 1 }}
                >
                  {moment(selectedEvent.start).format("h:mm A")}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Location:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 400,
                    flexShrink: 1,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {selectedEvent.location}
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Description:
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 400,
                    flexShrink: 1,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {selectedEvent.description}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  Organized by:
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 400 }}>
                  {selectedEvent.organizationName}
                </Typography>
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            padding: "10px 20px",
            borderTop: "1px solid #ddd",
          }}
        >
          <Button onClick={handleClose} sx={{ backgroundColor: 'black' }} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
